import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Table from "../../../ui/Table";
import { TitleText } from "../../../ui/Text";
import TableFormatter, {
  EditDeleteFormatter,
} from "../../../ui/TableFormatter";
import AddCompany from "./AddCompany";
import Modal from "../../../ui/Modal";
import { GetHook } from "../../../api/api";
import { COMPANY_URL } from "../../../api/urls";

import axios from "axios";
import { get } from "../../../utils/get";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

export const Company = () => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [handleSubmit, setHandleSubmit] = useState();
  const [editData, setEditData] = useState({});
  const [edit, setEdit] = useState(false);
  const [companies, setCompanies] = useState([]);
  const { data, error, pending, reload } = GetHook(COMPANY_URL);

  const location = useLocation();

  useEffect(() => {
    setCompanies(data);
    return () => {};
  }, [data]);

  const handleEdit: any = (row: any) => {
    setisModalOpen(true);
    setEdit(true);
    setEditData(row);
  };

  const closeModal = () => {
    setisModalOpen(false);
    setEdit(false);
    setEditData({});
    reload(get(location, "key"));
  };

  const handleDelete = (id: string) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        if (id) {
          axios
            .delete(`${COMPANY_URL}/${id}`)
            .then((res) => {
              setCompanies(
                companies.filter((company: any) => company.id != id)
              );
              toast.success("Company has been deleted");
              reload(get(location, "key"));
            })
            .catch((error) => toast.error(error.response.data.message));
        }
      }
    });
  };

  const columns = [
    {
      Header: "Company Name",
      accessor: "comapny_name",
      Cell: ({ row }: any) => (
        <TableFormatter
          name={row.original.name}
          url={row.original.avatar_url}
        />
      ),
    },
    {
      Header: "Description",
      accessor: "notes",
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ row }) =>
        row.original.active === true ? (
          <Status color="#13C997">Active</Status>
        ) : (
          <Status color="#FF6666">Non-Active</Status>
        ),
    },
    {
      id: "1",
      Header: "",
      Cell: ({ row }: any) => (
        <EditDeleteFormatter
          showEdit={() => handleEdit(row.original)}
          handleDelete={() => handleDelete(row.original.id)}
        />
      ),
    },
  ];
  return (
    <>
      <CompanyContainer>
        <HeaderContainer>
          <TitleText>Company</TitleText>
        </HeaderContainer>
        <Table data={companies} columns={columns} setModal={setisModalOpen} />
      </CompanyContainer>
      {isModalOpen && (
        <Modal
          title={edit ? "Edit Company" : "Add new Company"}
          handleSubmit={handleSubmit}
          closeModal={closeModal}
        >
          <AddCompany
            closseModal={closeModal}
            setHandleSubmit={setHandleSubmit}
            editData={editData}
            setCompanies={setCompanies}
            companies={companies}
          />
        </Modal>
      )}
    </>
  );
};

const CompanyContainer = styled.div`
  display: grid;
  grid-template-rows: 5em auto;
  background-color: #fff;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.3em;
  border-bottom: 1px solid rgba(55, 81, 255, 0.1);
`;

const Status = styled.span`
  color: ${(props) => props.color};
  font-size: 12px;
`;
